export default __webpack_public_path__ + "static/media/Pretendard-Bold.f6866c5e.woff";